import ChannelContext from "@jetshop/core/components/ChannelContext";
import { useContext, useEffect, useState } from "react";
import { fetchProductReviews } from "../../TestFreaks/Api";
import { getHostname } from "../../Core/Util/Helpers";
import { generateProductReviewsStructuredData } from "../../Jsonld/Construction/ProductReview";
import { SiteContext } from "../../Global/SiteContext";

const useTestFreakReviews = () => {
   const { setProductReviews, activeVariant } = useContext(SiteContext);
   const selectedChannel = useContext(ChannelContext)?.selectedChannel;
   const [structuredReviewData, setStructuredReviewData] = useState(null);

   useEffect(() => {
      if (!activeVariant?.articleNumber) return;

      // Flag to ensure updates are only applied from the latest fetch request.
      let isLatestRequest = true;

      const fetchReviews = async () => {
         try {
            const res = await fetchProductReviews(
               activeVariant.articleNumber,
               10,
               1,
               getHostname(selectedChannel?.url, 'verktygsboden.se')
            );

            if (isLatestRequest) {
               setProductReviews(res);
               const productReviewsStructuredData = generateProductReviewsStructuredData(
                  res?.summary,
                  activeVariant,
                  selectedChannel?.id
               );
               setStructuredReviewData(productReviewsStructuredData);
            }
         } catch (error) {
            if (isLatestRequest) {
               setProductReviews(null);
            }
         }
      };

      fetchReviews();

      return () => {
         isLatestRequest = false;  // Set when the effect cleanup runs to prevent state updates from old fetches
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [activeVariant]);

   return { structuredReviewData };
}

export default useTestFreakReviews;
